import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignJobBoardQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignJobBoardType } from "@/types/response/CampaignJobBoardType";

interface UseCampaignJobBoardParams {
  campaignId: string;
  clientIntegrationModuleId: string;
  clientId?: string;
}

export function useCampaignJobBoard({
  campaignId,
  clientIntegrationModuleId,
  clientId,
}: UseCampaignJobBoardParams) {
  return useQuery<CampaignJobBoardType, AxiosError>({
    queryKey: campaignJobBoardQueryKeys.detail(campaignId, clientIntegrationModuleId, clientId),
    queryFn: () =>
      instance
        .get<CampaignJobBoardType>(
          `/api/v2/Campaigns/${campaignId}/Integrations/${clientIntegrationModuleId}`,
          {
            params: {
              clientId,
            },
          }
        )
        .then((res) => res.data),
    enabled: !!campaignId && !!clientIntegrationModuleId,
    refetchOnMount: true,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
